import axios from 'axios';

import { getHeaders } from 'utils/apiUtils';

interface GetRequestParams {
  endpoint: string;
  params: any;
  enforceClient?: boolean;
  signal?: AbortSignal;
}

export const runGetApiRequest = async (
  {
    endpoint,
    params,
    enforceClient = false,
    signal,
  }: GetRequestParams,
) => (
  axios.get(
    endpoint,
    {
      params,
      signal,
      headers: getHeaders({ enforceClient }),
    },
  )
);

export const runPostApiRequest = async (endpoint: string, data?: any, params: any = {}, anonToken: string = '') => (
  axios.post(
    endpoint,
    data,
    {
      params,
      headers: getHeaders({ anonToken }),
    },
  )
);

export const runUpdateApiRequest = async (endpoint: string, data: any, params: any = {}) => (
  axios.put(
    endpoint,
    data,
    {
      params,
      headers: getHeaders(),
    },
  )
);

export const runPatchApiRequest = async (endpoint: string, data: any, params: any = {}) => (
  axios.patch(
    endpoint,
    data,
    {
      params,
      headers: getHeaders(),
    },
  )
);

export const runDeleteApiRequest = async (endpoint: string, params: any = {}) => (
  axios.delete(
    endpoint,
    {
      params,
      headers: getHeaders(),
    },
  )
);
